import { appConstants } from '../constant/app.constant';
import loginService from './login.service';

const supportUrl = () => (loginService.isFaciliter()
    ? appConstants.faciliterSupportUrl
    : appConstants.whatsappSupportUrl);

const supportContactService = { supportUrl };

export default supportContactService;
